module.exports = __webpack_public_path__ + "static/link-buttonaction-do-5ebd301b8792466cf9ebdbf288cca528.png";